import { render, staticRenderFns } from "./PrimePayersCatalog.vue?vue&type=template&id=5ec376a4&scoped=true"
import script from "./PrimePayersCatalog.vue?vue&type=script&lang=js"
export * from "./PrimePayersCatalog.vue?vue&type=script&lang=js"
import style0 from "./PrimePayersCatalog.vue?vue&type=style&index=0&id=5ec376a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec376a4",
  null
  
)

export default component.exports